namespace Matrix.Data {
    export class AccountHoldingColumns {
        static columnsKey = 'Data.AccountHolding';
    }
}
